export default __webpack_public_path__ + "static/media/plus.0de9dfe1.svg";